import * as analytic from '@anm/analytic';
import authLogger from '@anm/auth/helpers/debugger';
import browserStore from '@anm/helpers/browserStore';
import hasAuthAccess from '@anm/auth/helpers/hasAuthAccess';
import { useCallback, useEffect } from 'react';

import getDestinationParams from '../helpers/getDestinationParams';
import getDestinationStorageKey from '../helpers/getDestinationStorageKey';
import { DestinationParams } from '../types';

export const TWITCH_PARAM = 'twitch';
export const YOUTUBE_PARAM = 'youtube';
export const LINKEDIN_PARAM = 'linkedin';
export const FACEBOOK_PARAM = 'facebook';

type ClosePopupProps = {
  params: DestinationParams;
  destinationParam?: string;
};

const useAddedDestination = () => {
  const closePopup = useCallback(({ params, destinationParam }: ClosePopupProps) => {
    const storageKey = getDestinationStorageKey(params.app);

    browserStore.set(storageKey, params);
    const isDestinationError = params.error;

    if (!isDestinationError && destinationParam) {
      analytic.trackMyStreamsAddDestination(destinationParam);
    }

    if (!hasAuthAccess()) {
      authLogger.error('No user token on add destination modal');
    }

    window.close();
  }, []);

  // facebook and linkedin destination event sent in stream/saga.ts after specific group/page/profile is selected

  useEffect(() => {
    const params = getDestinationParams(location.href);

    if (params.network === TWITCH_PARAM) {
      closePopup({ params, destinationParam: TWITCH_PARAM });
    } else if (params.network === YOUTUBE_PARAM) {
      closePopup({ params, destinationParam: YOUTUBE_PARAM });
    } else if (params.network === LINKEDIN_PARAM) {
      closePopup({ params });
    } else if (params.network === FACEBOOK_PARAM) {
      closePopup({ params });
    }
  }, []);
};

export default useAddedDestination;
